import { Component, Output, EventEmitter } from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {LoginFormService} from '../services/login-form.service';
import {AuthService} from '../services/auth-service';
import {UserEmailService} from '../services/userEmail.service';
import {MatDialogRef} from '@angular/material/dialog';
import {AppConfigService} from '../app-config.service';
import {Router} from '@angular/router';
import {MatSnackBar} from '@angular/material/snack-bar';

export interface CountryDTO {
  isocode: string;
  name: string;
}

export interface Adresses {
  RFC: string;
  firstName: string;
  lastName: string;
  postalCodeBilling: string;
  regimenFiscal: string;
  cfdi: string;
  middleName: string;
  isForeign: boolean;
  country: CountryDTO;
  company: string;
}

export interface AddressesForm {
  addresses: Adresses[];
}

@Component({
  selector: 'app-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.css']
})

export class LoginFormComponent {

  constructor(

      private loginFormService: LoginFormService,
      private authService: AuthService,
      private emailService: UserEmailService,
      public dialog: MatDialogRef<LoginFormComponent>,
      private configService: AppConfigService,
      private router: Router,
      private snackBar: MatSnackBar,
      private config: AppConfigService,

  ) {

    this.logoHeader = this.configService.getConfig().logoHeader;
  }
  user: string;
  hide = true;
  login = false;
  urlRegisterUser = this.config.getConfig().urlRegisterUser;
  urlResetPassword = this.config.getConfig().urlResetPassword;


  form: FormGroup = new FormGroup({

    username: new FormControl(''),
    password: new FormControl(''),

  });

  @Output() submitEM = new EventEmitter();
  error: string | null = null;

  logoHeader = '';
  companyName = '';

  protected readonly localStorage = localStorage;
  protected readonly window = window;
  private currentUrl: string;

  ngOnInit() {
    if (this.configService.getConfig().companyName === 'OD') {
      this.companyName = 'Office Depot';
    } else {
      this.companyName = 'RadioShack';
    }

    this.currentUrl = this.router.url;
  }

  submit() {
    if (this.form.valid) {
      // Guardar datos en localStorage o sessionStorage según convenga
      this.emailService.setEmail(this.form.value.username);
      console.log('localStorage antes de iniciar sesion:', localStorage.getItem('user'));

      localStorage.setItem('userEmail', this.form.value.username);
      localStorage.setItem('password', this.form.value.password);
      console.log('guardando en sessionStorage', this.form.value.username);

      // Primera petición: obtener el token de acceso
      this.loginFormService.getAccessToken(this.form.value).subscribe(
          (accessToken) => {
            console.log('AccessToken:', accessToken);
            this.loginFormService.validateUser(this.form.value.username, accessToken).subscribe(
                (validationResponse) => {
                  if (validationResponse) {
                    this.authService.setAddresses(validationResponse);

                    this.loginFormService.getUserName(this.form.value.username, accessToken).subscribe(
                        (getUserNameRespones) => {
                          this.authService.setUser(getUserNameRespones);
                          this.submitEM.emit(getUserNameRespones);
                          this.dialog.close(getUserNameRespones);
                          this.login = true;

                          this.snackBar.open('Se inició la sesión correctamente.', 'Cerrar', {
                            duration: 3000,
                            horizontalPosition: 'center',
                            verticalPosition: 'top',
                            panelClass: 'success-snackbar',
                          });

                          if (this.currentUrl === '/listDatosF') {
                            window.location.reload();
                          } else {
                            this.router.navigate(['/listDatosF']);

                          }

                        },
                        (userNameError) => {
                          console.error('Error al obtener el nombre del cliente', userNameError);
                          this.error = 'No se pudo obtener el nombre del cliente';
                        }
                    );
                  } else {
                    this.error = 'Correo o Contraseña incorrectos';
                  }
                },
                (validationError) => {
                  console.error('Error en la validación del usuario', validationError);
                  this.error = 'Hubo un error al validar el usuario';
                }
            );
          },
          (accessTokenError) => {
            console.error('Error al obtener el token de acceso', accessTokenError);
            this.error = 'Hubo un error al iniciar sesión';
          }
      );
    } else {
      this.error = 'Formulario no válido';
    }
  }
}
